import React from "react";
import { Box, Button, Container, useMediaQuery, useTheme } from "@mui/material";
import Headings from "../../common/headings/headings";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useHistory } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`vertical-tabpanel-${index}`} aria-labelledby={`vertical-tab-${index}`} {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function Experience() {
  const theme = useTheme();
  const history = useHistory();

  // const ltxs = useMediaQuery(theme.breakpoints.down("xs"));
  const ltsm = useMediaQuery(theme.breakpoints.down("sm"));

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const navigateTo = () => {
    history.push("explore/all");
  };
  return (
    <>
      <Container maxWidth="lg">
        <div className="ui-padding--32"></div>

        <Headings heading="Worked at"></Headings>
        <div className="ui-padding--24"></div>
        <Box display="flex" flexDirection={ltsm ? "column" : "row"} minHeight={ltsm ? 450 : 290}>
          <Tabs
            orientation={ltsm ? "horizontal" : "vertical"}
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{ borderRight: 1, borderColor: "divider", minWidth: { md: "260px" } }}
          >
            <Tab className="ui-typo--h5 ui-font-weight--bold ui-flex--align-start" label="Axio (Amazon)" {...a11yProps(0)} />
            <Tab className="ui-typo--h5 ui-font-weight--bold ui-flex--align-start" label="Thedroid.io" {...a11yProps(1)} />
            <Tab className="ui-typo--h5 ui-font-weight--bold ui-flex--align-start" label="CIOC FMCG" {...a11yProps(2)} />
          </Tabs>
          <TabPanel value={value} index={0}>
            <Box p={4} className="frosted-glass">
              <h4 className="ui-typo--h4">
                <b>Senior Member of Technical Staff</b>
              </h4>
              <p className="ui-typo--h6">Oct 2021 - Present</p>
              <div>
                <ul>
                  <li className="ui-typo--body1 ui-padding--v-4 app-summary">
                    Spearheaded the complete frontend evolution of multiple high-scale BNPL platforms (Amazon Pay Later, Tata Pay Later, Xiaomi Easy Finance, Axio Pay Later) from AngularJS → Angular
                    11 → Angular 19, driving performance, security, and maintainability improvements through NgRx state management and modular architecture design.
                  </li>
                  <li className="ui-typo--h6 ui-padding--v-4 app-summary">
                    Engineered and optimized RESTful APIs that integrated seamlessly with mission-critical internal services (payments, mandate management, product catalog, consent systems),
                    accelerating new feature development across product lines.
                  </li>
                  <li className="ui-typo--h6 ui-padding--v-4 app-summary">
                    Built and maintained backend microservices using Python Flask and MySQL, including high-traffic product discovery and listing services for major merchants like Xiaomi.
                  </li>
                  <li className="ui-typo--h6 ui-padding--v-4 app-summary">
                    Designed a robust Consent Management Framework, including a zero-downtime data migration and backfill strategy, ensuring regulatory compliance and secure onboarding for millions of
                    users.
                  </li>
                  <li className="ui-typo--h6 ui-padding--v-4 app-summary">
                    Enhanced observability and operational excellence by integrating GA4 for customer behavior analytics and implementing monitoring & logging pipelines via AWS CloudWatch and
                    OpenSearch, leading to faster issue triage and improved platform stability.
                  </li>
                  <li className="ui-typo--h6 ui-padding--v-4 app-summary">
                    Drove cross-functional architectural collaboration across payments, user identity, and merchant integration teams — delivering scalable, secure, and performant BNPL products
                    adopted by 1000+ merchants and millions of monthly users.
                  </li>
                  <li className="ui-typo--h6 ui-padding--v-4 app-summary">
                    Mentored junior engineers, contributed to coding standards, and championed best practices in design patterns, performance optimization, and CI/CD workflows.
                  </li>
                </ul>
                {/* <ul>
                  <li className="ui-typo--body1 ui-padding--v-4">Developed and shipped highly interactive web applications made using Angularjs and Angular 11.</li>
                  <li className="ui-typo--body1 ui-padding--v-4">
                    Implemented the front-end of pay later products and features like
                    <ul>
                      <li>UPI autopay</li>
                      <li>Enach mandate setup</li>
                    </ul>
                  </li>
                  <li className="ui-typo--body1 ui-padding--v-4">Worked on the Axio pay later a User-based BNPL Product for easy checkout, is available to over 1000+ merchants.</li>
                  <li>Acquired knowledge of Tools and services like AWS Cloud watch for backend API logging and monitoring.</li>
                </ul> */}
              </div>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Box p={4} className="frosted-glass">
              <h4 className="ui-typo--h4">
                <b>Full stack Developer</b>
              </h4>
              <p className="ui-typo--h6">July 2019 - Oct 2021</p>
              <div>
                <ul>
                  <li  className="ui-typo--body1 ui-padding--v-4 app-summary"> Developed and contributed to 20+ web applications using Frontend framework, Node.js, and Firebase, focusing
                    on responsive design, scalability, and user experience.</li>
                  <li  className="ui-typo--body1 ui-padding--v-4 app-summary"> Built and maintained Admin, Partner, and User dashboards across domains such as B2B Pharma (Saveo), EdTech
                    (PlanB), Social Commerce (Thisability), and PropTech (Sneed).</li>
                  <li  className="ui-typo--body1 ui-padding--v-4 app-summary">Designed and integrated API endpoints (Node.js + Firebase) to support web apps with secure and real-time data
                    handling.</li>
                  <li  className="ui-typo--body1 ui-padding--v-4 app-summary"> Collaborated with cross-functional teams to deliver modular, maintainable applications, ensuring client satisfaction
                    and long-term engagement.</li>
                  <li  className="ui-typo--body1 ui-padding--v-4 app-summary"> Designed and developed interactive dashboards using React.js and Next.js, integrating charts and data
                    visualization libraries to present real-time insights and improve decision-making.</li>
                  <li  className="ui-typo--body1 ui-padding--v-4 app-summary"> Integrated and managed RESTful APIs for dynamic data rendering, ensuring secure, reliable, and optimized
                    frontend-backend communication.
                  </li>
                  <li  className="ui-typo--body1 ui-padding--v-4 app-summary"> Built reusable, modular UI components and design systems using shadcn/ui, Material UI, and Tailwind CSS,
                    improving development efficiency and UI consistency across projects.</li>
                  <li  className="ui-typo--body1 ui-padding--v-4 app-summary"> Implemented advanced state management solutions using Redux, Zustand, and RxJS, ensuring predictable state
                    flow, simplifying global state handling and improving application performance and improved maintainability in
                    large-scale applications.</li>


                  {/* <li className="ui-typo--body1 ui-padding--v-4 app-summary">
                    Developed and contributed to 20+ web applications using Angular, React.js, Next.js, Node.js, and Firebase, focusing on responsive design, scalability, and user experience.
                  </li>
                  <li className="ui-typo--body1 ui-padding--v-4 app-summary">
                    Built and maintained Admin, Partner, and User dashboards across domains such as B2B Pharma (Saveo), EdTech (PlanB), Social Commerce (Thisability), and PropTech (Sneed)..
                  </li>
                  <li className="ui-typo--body1 ui-padding--v-4 app-summary">
                    Collaborated with cross-functional teams to deliver modular, maintainable applications, ensuring client satisfaction and long-term engagement
                  </li>
                  <li className="ui-typo--body1 ui-padding--v-4 app-summary"> Designed and integrated API endpoints (Node.js + Firebase) to support web apps with secure and real-time data handling.</li> */}
                </ul>
              </div>
              <div className="ui-padding--16"></div>
              <div className={ltsm ? "ui-width--full ui-padding--h-56" : "ui-flex--justify-center"}>
                <Button className={ltsm ? "ui-width--full" : ""} variant={ltsm ? "contained" : "outlined"} size="large" color={"primary"} onClick={() => navigateTo()}>
                  Take me to the Projects
                </Button>
              </div>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Box p={4} className="frosted-glass">
              <h4 className="ui-typo--h4">
                <b>Intern</b>
              </h4>
              <p className="ui-typo--h6">Oct 2018 - Mar 2019</p>
              <div>
                <ul>
                  <li className="ui-typo--body1 ui-padding--v-4 app-summary">Developed an in-house web app, integrated libraries such as ReportLab, Chart.js, Fabric.js, Bootstrap and zkLib to
                    support reporting, data visualization, and interactive features.</li>
                  <li className="ui-typo--body1 ui-padding--v-4 app-summary">Built and maintained features for an edtech platform providing online study materials for IIT JEE preparation
                    Integrated tools like MathJax and ReportLab for rendering mathematical content and generating dynamic PDFs.</li>
                  <li className="ui-typo--body1 ui-padding--v-4 app-summary">Contributed to a full-stack development ERP system Django, Angular.js and Bootstrap, focusing on clean UI and
                    structured layout.</li>
                  <li className="ui-typo--body1 ui-padding--v-4 app-summary">Gained hands-on experience in project architecture, folder structuring, and static asset management.</li>
                </ul>
              </div>
            </Box>
          </TabPanel>
        </Box>
        {/* <div className="ui-border ui-border--r24 ui-blury--white">
                    <Box  display="flex">
                        <Box flex={1} py={2} className="ui-flex--justify-center">
                            <div>
                                <h1 className="ui-typo--h3 ui-font-weight--bold"> 20+</h1>
                                <span className="ui-font-weight--bold">Projects</span>
                            </div>
                        </Box>
                        <Box flex={1} py={2} className="ui-flex--justify-center">
                            <div>
                                <h1 className="ui-typo--h3 ui-font-weight--bold"> 20+</h1>
                                <span className="ui-font-weight--bold">Projects</span>
                            </div>
                        </Box>
                        <Box flex={1} py={2} className="ui-flex--justify-center">
                            <div>
                                <h1 className="ui-typo--h3 ui-font-weight--bold"> 20+</h1>
                                <span className="ui-font-weight--bold">Projects</span>
                            </div>
                        </Box>
                    </Box>
                </div> */}
      </Container>
    </>
  );
}
// import { Box, Container } from '@mui/material'
// import React from 'react'

// export default function Experience() {
//     return (
//         <>
//             <Container maxWidth="lg">
//                 <div className="ui-border ui-border--r24 ui-blury--white">
//                     <Box  display="flex">
//                         <Box flex={1} py={2} className="ui-flex--justify-center">
//                             <div>
//                                 <h1 className="ui-typo--h3 ui-font-weight--bold"> 20+</h1>
//                                 <span className="ui-font-weight--bold">Projects</span>
//                             </div>
//                         </Box>
//                         <Box flex={1} py={2} className="ui-flex--justify-center">
//                             <div>
//                                 <h1 className="ui-typo--h3 ui-font-weight--bold"> 20+</h1>
//                                 <span className="ui-font-weight--bold">Projects</span>
//                             </div>
//                         </Box>
//                         <Box flex={1} py={2} className="ui-flex--justify-center">
//                             <div>
//                                 <h1 className="ui-typo--h3 ui-font-weight--bold"> 20+</h1>
//                                 <span className="ui-font-weight--bold">Projects</span>
//                             </div>
//                         </Box>
//                     </Box>
//                 </div>
//             </Container>
//         </>
//     )
// }
